const util = {
  invoice_status: [
    {value: 'paper', name: '纸质'},
    {value: 'electronic', name: '电子'},
  ],
  invoice_types: [
    {value: -1, name: '未选择'},
    {value: -2, name: '无发票'},
    {value: 0, name: '普票'},
    {value: 1, name: '专票'},
    {value: 2, name: '国外发票'},
    {value: 3, name: '内部凭证'},
    {value: 4, name: '飞机票'},
    {value: 5, name: '火车票'},
    {value: 6, name: '客运汽车'},
    {value: 7, name: '出租车发票'},
    {value: 8, name: '电子普票-运输'},
    {value: 9, name: '国外发票(生成器生成)'},
    {value: 10, name: '税票'},
    {value: 100, name: '其他'},
  ],
  income_invoice_types: [
    {value: -1, name: '未选择'},
    {value: 0, name: '普票'},
    {value: 1, name: '专票'}
  ],
  getTaxRate(rate) {
    return math.eval(`${rate} * 100`) + '%';
  }
}
const invoice_types_hash = util.invoice_types.toHash('value', 'name')
util.getInvoiceType = type => {
  const name = invoice_types_hash[type];
  return name ? name : '未定义发票类型';
}

const invoice_ocr_hash = {
  10100: '增值税专用发票',
  10200: '定额发票',
  10507: '过路费发票',
  10101: '增值税普通发票',
  10400: '机打发票',
  10900: '可报销其他发票',
  10102: '增值税电子普通发票',
  10500: '出租车发票',
  10103: '增值税普通发票(卷票)',
  10503: '火车票',
  20100: '国际小票',
  10104: '机动车销售统一发票',
  10505: '客运汽车',
  20105: '滴滴出行行程单',
  10105: '二手车销售统一发票',
  10506: '航空运输电子客票行程单',
  10902: '完税证明',
  '10505a': '船票',
  10107: '数电票(增值税专用发票）',
  10108: '数电票(普通发票)',  
}

util.getInvoiceOCRType = type => {
  if (!type) return "-"
  const name = invoice_ocr_hash[type];
  return name ? name : '-';
}

export default util;
